import classNames from 'classnames';
import React, { FC, ReactNode } from 'react';

import styles from './RoundedListItem.styles.m.css';

export type IRoundedListItemSize = 'medium-1' | 'medium-2';

interface IRoundedListItemProps {
  onClick?(): void;
  isDisabled?: boolean;
  title?: ReactNode;
  subtitle?: ReactNode;
  prefix?: ReactNode;
  suffix?: ReactNode;
  size?: IRoundedListItemSize;
  className?: string;
}

/**
 * @description UI-kit component from Figma
 * https://www.figma.com/design/XBThpytw4C7kpJzNOymF02/%E2%9D%96-Web?node-id=21770-71843&m=dev&focus-id=21786-14508
 */

export const RoundedListItem: FC<IRoundedListItemProps> = (props) => {
  const {
    onClick,
    subtitle,
    title,
    prefix,
    suffix,
    size = 'medium-1',
    className,
    isDisabled,
  } = props;
  const Container = onClick ? 'button' : 'div';
  const containerClassName = classNames(styles.container, className, styles[`${size}-size`]);

  return (
    <Container
      disabled={isDisabled}
      className={containerClassName}
      onClick={!isDisabled ? onClick : undefined}
    >
      {prefix && <span className={styles.prefix}>{prefix}</span>}
      <div className={styles.info}>
        <p className={styles.title}>{title}</p>
        <p className={styles.subtitle}>{subtitle}</p>
      </div>
      {suffix && <span className={styles.suffix}>{suffix}</span>}
    </Container>
  );
};
